export enum ADVANCE_INDICATOR_INPUT_TYPE {
    INDICATOR = 'Indicators',
    MATH_OPERATION = 'Math Functions',
    COMPARATOR = 'Comparators',
    NUMBER = 'Number',
    SYMBOL = 'Symbol',
}
